import axios from "axios";
import Config from "../utils/Config";

class ClaimService {
  getAuthHeaders() {
    return {
      headers: {
        "Content-Type": "application/json",
        Authorization: `Bearer ${localStorage.getItem("token")}`,
      },
    };
  }

  async createClaim(payload) {
    try {
      const response = await axios.post(
        `${Config.apiUrl}/user/policy/claim`,
        payload,
        this.getAuthHeaders()
      );
      return {
        status: true,
        message: response.data?.data?.reason || "Claim created successfully",
        data: response.data?.data,
      };
    } catch (error) {
      return {
        status: false,
        message:
          error.response?.data?.data?.reason ||
          "An error occurred while creating claim",
        data: null,
      };
    }
  }

  async getClaims() {
    try {
      const response = await axios.get(
        `${Config.apiUrl}/user/policy/all/claim`,
        this.getAuthHeaders()
      );
      return {
        status: true,
        message: response.data?.data?.reason || "Claims fetched successfully",
        data: response.data?.data,
      };
    } catch (error) {
      return {
        status: false,
        message:
          error.response?.data?.data?.reason ||
          "An error occurred while getting claims",
        data: null,
      };
    }
  }
}

const claimService = new ClaimService();
export default claimService;
